module.exports = __webpack_public_path__ + "img/HINDU RED.e2508db.svg";